export const environment = {
    production: true,
    envName: 'staging',
    baseUrl: 'https://atlas-staging.centilytics.com/v2',
    wsBaseUrl: 'wss://atlas-staging.centilytics.com/ws',
    mock: false, // set this to true to use mock server to develop a widget
    mockComponent: null // set this to the component to render in case of MOCK_WIDGET PortletType
};
